// Failed SSO component displays the modal content notifying user they aren't signed up with Medsender.
// In the Medsender iOS app's sign-in sheet it offers no sign-up: App Review Guideline 5.1.1(v),
// and the app cannot finish a sign-in that leaves for the marketing site. Every other login,
// Gibraltar's included, shows the ordinary dialog.
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ModalWrapper from './ModalWrapper';

const pStyle = {
  textAlign: 'center',
  fontWeight: '600',
};

class FailedSSO extends Component {
  renderContent() {
    const { modalType: { data: { invalidDomain, iosAppSignIn } } } = this.props;

    if (invalidDomain) {
      return (
        <div>
          <p style={pStyle}>Login Failed</p>
          <p>
            You are trying to login with an invalid email domain for your Organization. Please contact your Medsender Admin.
          </p>
        </div>
      );
    }

    if (iosAppSignIn) {
      return (
        <div>
          <p style={pStyle}>Couldn&apos;t log in with Microsoft</p>
          <p>
            No Medsender account was found for this Microsoft account, or the Microsoft sign-in
            didn&apos;t finish. Log in with your email and password, or ask your
            organization&apos;s Medsender administrator.
          </p>
        </div>
      );
    }

    return (
      <div>
        <p style={pStyle}>You aren't signed up for Medsender</p>
        <p>
          Before you can use Medsender, you can sign up at&nbsp;
          <a href="https://medsender.com">medsender.com</a>
          &nbsp;and start using Medsender immediately.
        </p>
      </div>
    );
  }

  render() {
    const { hideModal } = this.props;
    const customContentStyle = {
      width: '400px',
    };

    return (
      <ModalWrapper
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        dismiss="Close"
      >
        {this.renderContent()}
      </ModalWrapper>
    );
  }
}

FailedSSO.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.shape({
    data: PropTypes.shape({
      // 'true' from the failure URL's query string.
      invalidDomain: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      iosAppSignIn: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default FailedSSO;
